import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    eventoId: 0,
    participanteId: 0,
    eventoEtapaId: 0,
    transferenciaId: 0,

    fechaAutorizacion: moment(new Date()).format('YYYY-MM-DD'),
    // fechaTransferencia: moment(new Date()).format('YYYY-MM-DD'),
    importe: 0,
    // completada: false,
    observaciones: '',
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, params) {
        state.eventoId = params.eventoId;
        state.participanteId = params.participanteId;
        state.eventoEtapaId = params.eventoEtapaId || 0;
        state.transferenciaId = params.transferenciaId || 0;

        state.fechaAutorizacion = moment(new Date()).format('YYYY-MM-DD');
        state.importe = params.importe || 0;
        state.observaciones = '';
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', params);
            resolve();
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';
            
            if (save) {
                let transferencia= {
                    participanteId: state.participanteId,
                    eventoEtapaId: parseInt(state.eventoEtapaId),
                    fechaAutorizacion: moment(state.fechaAutorizacion).format('YYYY-MM-DD'),
                    importe: parseFloat(state.importe),
                    observaciones: state.observaciones.trim(),
                    transferenciaId: state.transferenciaId
                };
                
                let url = 'eventos/' + state.eventoId + '/participante/' + state.participanteId + '/transferencias';

                apiAxios.post(url, transferencia)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}